export const LOADING_STATUSES = {
    SUCCESS: 'success',
    ERROR: 'error',
    PENDING: 'pending',
};

export const TAG_DISPLAY_TEXT = {
    EVENT: 'Event',
    RESPIRATORY: 'RE',
    COMMENT: 'Comment',
    DESATURATION: 'DE',
    POSITION: 'Position',
    UPRIGHT: 'Upright',
    SUPINE: 'Supine',
    NONSUPINE: 'Non-Supine',
    SIGNAL: 'Signal Quality',
    CENTRAL: 'Central',
    OBSTRUCTIVE: 'Obstructive',
    APNEA: 'Apnea',
    HYPOPNEA: 'Hypopnea',
    DROPOUT: 'Signal Loss',
    ARTIFACT: 'Artifact',
    MOTION: 'Motion',
    HYPNOGRAM: 'Hypnogram',
    N1: 'n1',
    N2: 'n2',
    N3: 'n3',
    REM: 'REM',
    WAKE: 'Wake',
};

export { Tags as TAGS } from '~/services/Edf/constants';
